import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UpdateMonthlyLimitDialogData, UpdateMonthlyLimitDialogResult } from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { CurrencyInputComponent } from '../currency-selection-component/currency-input.component';
@Component({
  templateUrl: './update-monthly-limit-dialog.html',
  styleUrls: ['./update-monthly-limit-dialog.scss'],
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatOptionModule, MatSelectModule, FormsModule, ReactiveFormsModule, FlexModule, MatButtonModule, MatDialogModule, CurrencyInputComponent]
})
export class UpdateMonthlyLimitDialog {

  formGroup: FormGroup<{
    maxLimit: FormControl<number | null>;
  }>;
  formControl: FormControl<number | null>;
  maxValue: number;

  constructor(@Inject(MAT_DIALOG_DATA) public data: UpdateMonthlyLimitDialogData,
    private matDialogRef: MatDialogRef<UpdateMonthlyLimitDialog, UpdateMonthlyLimitDialogResult>,
    private formBuilder: FormBuilder) {
    this.formControl = formBuilder.control(data.limit ?? null, [Validators.required, Validators.max(data.maxValue)]);
    this.maxValue = data.maxValue;
    this.formGroup = formBuilder.group({
      maxLimit: this.formControl,
    })
  }

  onCancel($event: Event) {
    this.matDialogRef.close({
      readyForSubmission: false,
      maxLimit: this.formControl.value ?? null
    });
  }

  onSubmit($event: Event) {
    if (this.formControl.valid) {
      this.matDialogRef.close({
        readyForSubmission: true,
        maxLimit: this.formControl.value ?? null
      });
    }
  }
}
